import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Moon, Sun, Menu, X, ShieldCheck, ChevronRight } from "lucide-react";
import { useTheme } from "../../context/ThemeContext";
import { useAuth } from "../../context/AuthContext";
import logo from "../../assets/access wealth logo icon light.png";
import logo2 from "../../assets/access wealth logo icon.png";

export default function Navbar() {
  const { theme, toggle } = useTheme();
  const { user } = useAuth();
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();

  const links = [
    { to: "/calculators", label: "Calculators" },

    { to: "/pricing", label: "Pricing" },
  ];

  return (
    <header className="glass-header sticky top-0 z-40">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <Link
            to="/"
            data-testid="brand-home-link"
            className="flex items-center gap-2 group"
          >
            <div className="grid h-12 w-10 place-items-center  overflow-hidden">
              {theme == "dark" ? (
                <>
                  <img
                    src={logo}
                    alt="AccessWealth"
                    className="h-full w-full object-cover"
                  />
                </>
              ) : (
                <>
                  <img
                    src={logo2}
                    alt="AccessWealth"
                    className="h-full w-full object-cover"
                  />
                </>
              )}
            </div>
            <div className="flex flex-col leading-tight">
              <span className="font-display text-lg font-bold tracking-tight text-slate-900 dark:text-white">
                AccessWealth
              </span>
              <span className="text-[10px] text-slate-500 dark:text-slate-400 -mt-1">
                Personal Wealth OS
              </span>
            </div>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}-link`}
                className="px-3 py-2 text-sm font-medium text-slate-600 dark:text-slate-300 hover:text-slate-900 dark:hover:text-white rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <button
              onClick={toggle}
              data-testid="theme-toggle-btn"
              aria-label="Toggle theme"
              className="grid h-9 w-9 place-items-center rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors text-slate-600 dark:text-slate-300"
            >
              {theme === "dark" ? (
                <Sun className="h-4 w-4" />
              ) : (
                <Moon className="h-4 w-4" />
              )}
            </button>

            {user && user.id ? (
              <button
                onClick={() => navigate("/dashboard")}
                data-testid="goto-dashboard-btn"
                className="btn-primary !py-2 !px-4 !text-sm"
              >
                Dashboard <ChevronRight className="h-4 w-4" />
              </button>
            ) : (
              <>
                <Link
                  to="/login"
                  data-testid="nav-login-link"
                  className="hidden sm:inline-flex items-center px-4 py-2 text-sm font-semibold text-slate-700 dark:text-slate-200 hover:text-slate-900 dark:hover:text-white"
                >
                  Sign in
                </Link>
                <Link
                  to="/register"
                  data-testid="nav-signup-cta"
                  className="btn-primary !py-2 !px-4 !text-sm"
                >
                  Get Started
                </Link>
              </>
            )}

            <button
              onClick={() => setOpen((v) => !v)}
              data-testid="nav-mobile-toggle"
              className="md:hidden grid h-9 w-9 place-items-center rounded-lg text-slate-600 dark:text-slate-300"
            >
              {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
            </button>
          </div>
        </div>

        {open && (
          <div className="md:hidden pb-4 grid gap-1">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className="px-3 py-2 text-sm font-medium text-slate-700 dark:text-slate-200 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800"
              >
                {l.label}
              </Link>
            ))}
          </div>
        )}
      </div>
    </header>
  );
}
